import React from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';

const ConfirmForceRecreation = ({ handleAccept, handleReject, taskType }) => (
  <Modal open>
    <Modal.Header>
      {taskType === 'LFN' ? 'Legal Formal Notice' : 'Court Application'} already
      exists
    </Modal.Header>
    <Modal.Content>
      <Modal.Description>
        Do you want to overwrite existing document?
      </Modal.Description>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={handleReject} color="red" inverted>
        <Icon name="remove" /> No
      </Button>
      <Button onClick={handleAccept} color="green" inverted>
        <Icon name="checkmark" /> Yes
      </Button>
    </Modal.Actions>
  </Modal>
);

export default ConfirmForceRecreation;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/ConfirmForceRecreation.js